module.exports = __webpack_public_path__ + "img/pink-stairway-kopi.6530b43b.png";